/* Crystal Outlet theme script */
(function () {
  'use strict';
  var T = window.theme || {};
  var R = T.routes || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = T.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return dollars + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(cents, 0);
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        case 'amount_with_space_separator': return delim(cents, 2, ' ', ',');
        default: return delim(cents, 2);
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- delivery estimate ---------- */
  function addBusinessDays(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w > 0 && w < 6) n--; }
    return d;
  }
  function fmtDate(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function fillEstimates(root) {
    var a = fmtDate(addBusinessDays(T.shipMin || 3)), b = fmtDate(addBusinessDays(T.shipMax || 7));
    $$('.se1', root).forEach(function (e) { e.textContent = a; });
    $$('.se2', root).forEach(function (e) { e.textContent = b; });
  }

  /* ---------- overlay, menu, drawer ---------- */
  var ov, menu, drawer;
  function syncOverlay() { if (ov) ov.hidden = (!menu || menu.hidden) && (!drawer || drawer.hidden); }
  function openMenu() { if (!menu) return; menu.hidden = false; syncOverlay(); var x = $('#mx'); if (x) x.focus(); }
  function closeMenu() { if (!menu) return; menu.hidden = true; syncOverlay(); }
  function openDrawer() { if (!drawer) return; drawer.hidden = false; syncOverlay(); refreshCart(); var x = $('#dx'); if (x) x.focus(); }
  function closeDrawer() { if (!drawer) return; drawer.hidden = true; syncOverlay(); }

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; });
    var c = $('#cart'); if (c) c.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }
  function showError(msg) {
    var e = $('#derr'); if (!e) return;
    e.textContent = msg || ''; e.hidden = !msg;
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var list = $('#dlines'), foot = $('#dfoot');
    if (!list) return;
    if (!cart.items.length) {
      list.innerHTML = '<p style="color:var(--mute)">Your cart is currently empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    list.innerHTML = cart.items.map(function (it, i) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
      var img = it.image ? '<img alt="" src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160') + '">' : '';
      return '<div class="li">' + img + '<div class="t"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="q"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="rm" data-line="' + (i + 1) + '" data-q="0">Remove</button></div><div>' + formatMoney(it.final_line_price) + '</div></div>';
    }).join('');
    var sub = $('#dsub'); if (sub) sub.textContent = formatMoney(cart.total_price);
    var free = $('#dfree');
    if (free) {
      if (T.freeShipping > 0) {
        free.hidden = false;
        free.textContent = cart.total_price >= T.freeShipping ? "You've unlocked free shipping." :
          "You're " + formatMoney(T.freeShipping - cart.total_price) + ' away from free shipping.';
      } else { free.hidden = true; }
    }
  }
  function refreshCart() {
    return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  function changeLine(line, qty) {
    if (drawer) drawer.classList.add('loading');
    return fetch((R.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (cart) { showError(''); renderCart(cart); })
      .catch(function (e) { showError((e && (e.description || e.message)) || 'Could not update your cart. Please try again.'); })
      .then(function () { if (drawer) drawer.classList.remove('loading'); });
  }
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"][name="add"]');
    var err = form.querySelector('[data-error]') || (form.closest('[data-product-section]') ? $('[data-error]', form.closest('[data-product-section]')) : null);
    if (btn) btn.classList.add('loading');
    if (err) { err.hidden = true; err.textContent = ''; }
    return fetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { openDrawer(); })
      .catch(function (e) {
        var msg = (e && (e.description || e.message)) || 'Could not add to cart. Please try again.';
        if (err) { err.textContent = msg; err.hidden = false; } else { openDrawer(); showError(msg); }
      })
      .then(function () { if (btn) btn.classList.remove('loading'); });
  }

  /* ---------- product page ---------- */
  function initProduct(sec) {
    var jsonEl = $('[data-product-json]', sec);
    var form = $('#pform', sec);
    if (!jsonEl || !form) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var selects = $$('[data-option-index]', sec);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add]', form);
    var stickyBtn = $('[data-sticky-add]', sec);
    var mainImg = $('#mainimg', sec);
    var thumbs = $$('.thumbs button', sec);

    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      return '<span class="now' + (sale ? ' sale' : '') + '">' + formatMoney(v.price) + '</span>' + (sale ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
    }
    function showMedia(id, src) {
      if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; }
      thumbs.forEach(function (t) { t.classList.toggle('on', String(t.dataset.mediaId) === String(id)); });
    }
    function currentVariant() {
      var opts = selects.map(function (s) { return s.value; });
      return product.variants.filter(function (v) {
        return opts.every(function (o, i) { return v.options[i] === o; });
      })[0];
    }
    function update() {
      var v = currentVariant();
      var available = !!(v && v.available);
      if (v) {
        idInput.value = v.id;
        $$('[data-price]', sec).forEach(function (p) { p.innerHTML = priceHTML(v); });
        if (v.featured_media) {
          var t = thumbs.filter(function (x) { return String(x.dataset.mediaId) === String(v.featured_media.id); })[0];
          showMedia(v.featured_media.id, t ? t.dataset.src : null);
        }
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }
      var label = !v ? 'Unavailable' : (available ? 'Add to cart' : 'Sold out');
      [addBtn, stickyBtn].forEach(function (b) { if (b) { b.disabled = !available; b.textContent = label; } });
      var stock = $('[data-stock]', sec);
      if (stock) stock.innerHTML = available ? '<span class="dot"></span>In stock, ready to ship' : '<span class="dot" style="background:var(--sale)"></span>' + label;
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaId, t.dataset.src); }); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(addBtn); else addToCart(form);
    });
    document.body.classList.add('onprod');
  }

  /* ---------- quantity steppers (product + cart page) ---------- */
  function initSteppers() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.qty [data-qty]'); if (!b) return;
      var input = b.parentNode.querySelector('input'); if (!input) return;
      var min = parseInt(input.min || '0', 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var cf = $('#cartform');
    if (cf) {
      var timer;
      cf.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="updates[]"]')) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          var fd = new FormData(cf); fd.append('update', '1');
          cf.classList.add('loading');
          fetch(R.cart || '/cart', { method: 'POST', body: fd }).then(function () { window.location.reload(); });
        }, 500);
      });
    }
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    ov = $('#ov'); menu = $('#menu'); drawer = $('#drawer');
    fillEstimates();

    var mb = $('#mb'); if (mb) mb.addEventListener('click', openMenu);
    var mx = $('#mx'); if (mx) mx.addEventListener('click', closeMenu);
    var dx = $('#dx'); if (dx) dx.addEventListener('click', closeDrawer);
    if (ov) ov.addEventListener('click', function () { closeMenu(); closeDrawer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); closeDrawer(); } });
    if (menu) $$('a', menu).forEach(function (a) { a.addEventListener('click', closeMenu); });

    var cartBtn = $('#cart');
    if (cartBtn && !document.body.classList.contains('template-cart')) {
      cartBtn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    }
    if (drawer) drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (!b) return;
      changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.q, 10));
    });

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f.matches && f.matches('form[data-type="add-to-cart-form"]')) { e.preventDefault(); addToCart(f); }
    });

    $$('[data-product-section]').forEach(initProduct);
    initSteppers();
  });

  window.CrystalOutlet = { formatMoney: formatMoney, openDrawer: openDrawer, refreshCart: refreshCart };
})();
